(() => {
  const overlay = document.getElementById('MioNewsletterPopup');
  const form = document.getElementById('MioPopupForm');
  const status = document.getElementById('MioPopupFormStatus')?.dataset.status;
  if (!overlay || !form || overlay.dataset.mioMeasurementInitialized) return;
  if (document.body.dataset.mioAnalyticsEnabled !== 'true' || window.Shopify?.designMode) return;
  if (new URLSearchParams(window.location.search).has('preview_theme_id')) return;
  overlay.dataset.mioMeasurementInitialized = 'true';

  const version = 'mio_popup_v1';
  const pendingKey = 'mio_popup_measurement_pending_v1';
  const expiryMs = 30 * 60 * 1000;
  const tagsInput = form.querySelector('input[name="contact[tags]"]');
  const originalTags = tagsInput?.value || 'newsletter,popup';
  let viewed = false;
  let dismissed = false;
  let confirmation = null;

  const device = () => window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop';
  const allowed = () => {
    try {
      return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
    } catch {
      return false;
    }
  };
  const emit = (action, viewport = device()) => {
    if (!allowed() || typeof window.mioClarity?.event !== 'function') return false;
    try {
      window.mioClarity.set('mio_popup_version', version);
      window.mioClarity.set('mio_popup_viewport', viewport);
      window.mioClarity.event(`mio_popup_${action}`);
      return true;
    } catch {
      return false;
    }
  };
  const clearPending = () => {
    try {
      window.sessionStorage.removeItem(pendingKey);
    } catch {
      return;
    }
  };
  const readPending = () => {
    try {
      const value = JSON.parse(window.sessionStorage.getItem(pendingKey) || 'null');
      if (!value || !['mobile', 'desktop'].includes(value.device)) return null;
      const age = Date.now() - value.at;
      return Number.isFinite(age) && age >= 0 && age < expiryMs ? value : null;
    } catch {
      return null;
    }
  };
  const offerVisible = () => status !== 'success' && !document.hidden &&
    overlay.getAttribute('data-open') === 'true' && overlay.getAttribute('aria-hidden') === 'false';
  const observeView = () => {
    if (!viewed && offerVisible() && emit('viewed')) viewed = true;
  };
  const observeConfirmation = () => {
    if (!confirmation || !allowed()) return;
    if (emit('subscribed', confirmation.device)) confirmation = null;
  };
  const observe = () => {
    observeView();
    observeConfirmation();
  };

  const pending = readPending();
  if (status === 'success' || status === 'error') {
    clearPending();
    if (pending && window.location.hash === '#MioPopupForm' && status === 'success') confirmation = pending;
  } else if (!pending) {
    clearPending();
  }

  form.addEventListener('submit', (event) => {
    if (event.defaultPrevented || !form.checkValidity()) return;
    if (tagsInput) tagsInput.value = originalTags;
    if (!allowed() || !offerVisible()) {
      clearPending();
      return;
    }
    observeView();
    const viewport = device();
    const submittedAt = Date.now();
    if (tagsInput) {
      const tags = originalTags.split(',').map((tag) => tag.trim()).filter(Boolean);
      tagsInput.value = [...new Set([...tags, version, `mio_popup_${viewport}`, `${version}_at_${submittedAt}_${viewport}`])].join(',');
    }
    try {
      window.sessionStorage.setItem(pendingKey, JSON.stringify({ at: submittedAt, device: viewport }));
    } catch {
      clearPending();
    }
    emit('submitted', viewport);
  });

  const observeDismiss = () => {
    if (!dismissed && viewed && offerVisible() && emit('dismissed')) dismissed = true;
  };
  overlay.addEventListener('mio:popup-dismissed', observeDismiss);
  new MutationObserver(observeView).observe(overlay, { attributes: true, attributeFilter: ['data-open', 'aria-hidden'] });
  document.addEventListener('visibilitychange', observeView);
  document.addEventListener('visitorConsentCollected', () => {
    if (!allowed()) {
      confirmation = null;
      clearPending();
      if (tagsInput) tagsInput.value = originalTags;
    }
    observe();
  });
  observe();
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (!error) observe();
    });
  }
})();
